import React from 'react'
import { Edit, SimpleForm, TextInput, NumberInput, useTranslate, BooleanInput } from 'react-admin'
import { Grid } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

export const FormulaGlobalVariablesEdit = (props) => {
  const translate = useTranslate()
  return (
    <Edit {...props} actions={null}>
      <CardCommon title={translate('ra.entity.formula-global-variables')} actions={null}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} btnDelete={true} fieldsName={['name']} />}>
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')}>
              <TextInput disabled source='name' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.value')}>
              <NumberInput label='' source='value' fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.show_breakdown')}>
              <BooleanInput label={translate('ra.field.show_breakdown')} source='show' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
